import Vue from 'vue'
import AppContainer from './AppContainer'
import AppCopyright from './AppCopyright'
import AppHeader from './AppHeader'
import FreeitemsList from './FreeitemsList'
import VideoletteritemsList from './VideoletteritemsList'
import AppFooter from './AppFooter'
import AppLoading from './AppLoading'
import CounselorsList from './CounselorsList'
import StepChart from './StepChart'
import StoreVideoPlayer from './StoreVideoPlayer'
import LoginForm from './LoginForm'
import RegisterForm from './RegisterForm'
import ProfileViewer from './ProfileViewer'

import EntryForm from './EntryForm/EntryForm'
import EntryFormLineDaily from './EntryForm/EntryFormLineDaily'
import EntryConfirm from './EntryForm/EntryConfirm'
import EntryConfirmLineDaily from './EntryForm/EntryConfirmLineDaily'
import EntryFormHeader from './EntryForm/EntryFormHeader'
import EntryFormHeaderNoSteps from './EntryForm/EntryFormHeaderNoSteps'
import EntryFormHeaderSpecial from './EntryForm/EntryFormHeaderSpecial'
import EntryFormHeaderLineDaily from './EntryForm/EntryFormHeaderLineDaily'

import ProductDetail from './ProductDetail'
import StoryTrial from './Trial/StoryTrial'
import StorySummary from './Trial/StorySummary'
import TrialHalfPeriod from './Trial/TrialHalfPeriod'
import HalfCarousel from './Trial/HalfCarousel'
import SecondRecommend from './Trial/SecondRecommend'

import StoryRecomend from './StoryRecomend'
import StoryResult from './StoryResult'
import StoryResultSecondHalf from './StoryResultSecondHalf'
import StoryResultSpecial from './StoryResultSpecial'
import ShareButtons from './ShareButtons'
import AppCarousel from './AppCarousel'
import UranaiImg from './UranaiImg'
import InquiryForm from './InquiryForm'
import AppDialog from './AppDialog'
import AppModal from './AppModal'
import AppModalSimple from './AppModalSimple'
import AppModalImage from './AppModalImage'
import LotteryItems from './LotteryItems'
import CreditCardForm from './Payment/CreditCardForm'
import PaymentMethodSelect from './Payment/PaymentMethodSelect'
import ChangePaymentDialog from './Payment/ChangePaymentDialog'
import ChangePaymentType from './Payment/ChangePaymentType'
import LastPayment from './Payment/LastPayment'
import AmazonPayButton from './Payment/AmazonPayButton'
import ConfirmationPurchase from './Payment/ConfirmationPurchase'
import FirstcomeShowcase from './FirstcomeShowcase'
import VideoletterProductDetail from './VideoletterProductDetail'
import CommentInput from './CommentInput'
import FirstcomeShowcaseHalfprice from './Trial/FirstcomeShowcaseHalfprice'
import VideoletterProductDetailHalfprice from './Trial/VideoletterProductDetailHalfprice'
import ScrollTop from './ScrollTop'
import ToppageScrollTop from './ToppageScrollTop'
import ModernList from './ModernList'
import UrageiList from './UrageiList'
import ModernCounselorCard from './ModernCounselorCard'
import ShowSample from './ShowSample'
import PopUpFooter from './PopUpFooter'
import ItemDetailText from './ItemDetailText'
import ItemDetailHeader from './ItemDetailHeader'
import PromotionContainer from './PromotionContainer'
import LoadingFullPage from './LoadingFullPage'
import VideoletterList from './VideoletterList'
import SnsRegister from './SnsRegister'
import SnsLogin from './SnsLogin'
import VideoletterEmpty from './VideoletterEmpty'
import ResultHeader from './ResultHeader'

import ProfileForm from './ProfileForm'
import NicknameForm from './NicknameForm'
import SnsregistForm from './SnsregistForm'
import PaymentForm from './PaymentForm'
import SnsRelation from './SnsRelation'

import LoginControllers from './LoginControllers'
import PreLogin from './PreLogin'
import SignInActionPanel from './SignInActionPanel'
import SignUpActionPanel from './SignUpActionPanel'
import IdentificationControllers from './IdentificationControllers'
import InformationMessage from './InformationMessage'
import InformationShop from './InformationShop'
import ProvisionalRegist from './ProvisionalRegist'
import ReAuthForm from './ReAuthForm'
import TweetList from './TweetList'
import MovieModal from './MovieModal'
import ItemLink from './ItemLink'
import ReadList from './ReadList'

import LpLicorice from './lp/licorice/LpLicorice'
import SnsLicorice from './SnsLicorice'
import LicoriceVideoPlayer from './LicoriceVideoPlayer'
import LicoriceComplete from './LicoriceComplete'

import TopDailyFortune from './TopDailyFortune'
import SwitchForm from './SwitchForm'
import CommentList from './CommentList'
import TopStarManage from './TopStarManage'
import EvaluateStars from './EvaluateStars'

import StoreVideoSampleMenu from './StoreVideoSampleMenu'
import ModernList2 from './ModernList2'
import SaleBanner from './SaleBanner'
import PersonalityList from './PersonalityList'
import CategoryUranaiList from './CategoryUranaiList'
import BreadCrumb from './BreadCrumb'

import YearLuck2020Top from './YearLuck/y2020/yearluck2020Top'
import YearLuck2020Summary from './YearLuck/y2020/yearluck2020Summary'
import YearLuck2020Result from './YearLuck/y2020/yearluck2020Result'
import YearLuck2020ResultSet from './YearLuck/y2020/yearluck2020ResultSet'

import PasswordChange from './PasswordChange'
import RegistControllers from './RegistControllers'
import RegistUserInfo from './RegistUserInfo'
import PaymentRegistForm from './PaymentRegistForm'
import SubscRejoin from './SubscRejoin'
// import ShortageUserInfo from './ShortageUserInfo'
import PaymentStatus from './PaymentStatus'
import PaymentHistory from './Payment/PaymentHistory'

// サブスク関連
import SelectThemeWorried from './Subscription/SelectThemeWorried'
import SubscConfirm from './SubscConfirm'
import SubscComplete from './SubscComplete'
import SubscCancel from './Subscription/SubscCancel'
import SubscCancelComplete from './Subscription/SubscCancelComplete'
import SubscChangedMind from './Subscription/SubscChangedMind'
import SubscSuspensionError from './Subscription/SubscSuspensionError'
import BuyButton from './partials/BuyButton'

import PresentMovie from './lp/PresentMovie'

// 特典系
import EntryKantei from './Favor/EntryKantei'
import ConfirmKantei from './Favor/ConfirmKantei'
import CompleteKantei from './Favor/CompleteKantei'

import TopPage from './Toppage/TopPage'

// アカウント関連 - アカウントを管理
import AccountEdit from './User/AccountEdit'
import EmailForm from './User/EmailForm'
import UserAccountEmailSend from './User/UserAccountEmailSend'
import UserAccountEmailComplete from './User/UserAccountEmailComplete'
import UserAccountPasswordConfirm from './User/UserAccountPasswordConfirm'
import UserAccountPassword from './User/UserAccountPassword'
import ReissuePasswordForm from './User/ReissuePasswordForm'
import MailMagConfig from './User/MailMagConfig'
import UserAccountPasswordComplete from './User/UserAccountPasswordComplete'

// アカウント関連 - 保有ポイントを管理
import UserAccountPoint from './User/UserAccountPoint'

// 決済系
import PaymentLibrary from './Payment/PaymentLibrary' // 購入履歴

// プレイリスト
import PlaylistBase from './Playlist/PlaylistBase'

// ヘルプ
import HelpPage from './Help/Help'
import FaqPage from './Help/Faq'
import LegalPage from './Help/Legal'
import PrivacyPage from './Help/Privacy'
import TermsPage from './Help/Terms'
import CookiePage from './Help/Cookie'
import AnnouncementPage from './Help/Announcement'
import TerminationPage from './Help/Termination'

//デジコンエラーページ
import OutofService from './OutofService'

import MultiplePartnerList from './MultiplePartnerList'

// 年運2021
import yearLuck2021Top from './YearLuck/y2021/yearluck2021Top'
import yearLuck2021Lp from './YearLuck/y2021/yearluck2021Lp'
import yearLuck2021Result from './YearLuck/y2021/yearluck2021Result'

// 年運2022
import yearLuck2022Top from './YearLuck/y2022/yearluck2022Top'
import yearLuck2022Lp from './YearLuck/y2022/yearluck2022Lp'
import yearLuck2022Result from './YearLuck/y2022/yearluck2022Result'

//超運ダイアリー課金
import AppContainerChoun from './AppContainerChoun'
import PaymentChounRegistForm from './ChounDiary/PaymentChounRegistForm'
import PaymentStatusChoun from './ChounDiary/PaymentStatusChoun'
import PaymentFormChoun from './ChounDiary/PaymentFormChoun'
import PaymentDetailChoun from './ChounDiary/PaymentDetailChoun'
import CancelChoun from './ChounDiary/CancelChoun'
import SubscConfirmChoun from './ChounDiary/SubscConfirmChoun'

// LP
import Cutout01 from './lp/Cutout/01'

// アカデミー
import AcademyPaymentStatus from './Academy/pages/PaymentStatus'
import AcademyPaymentForm from './Academy/pages/PaymentForm'
import AcademyPaymentInput from './Academy/pages/PaymentInput'
import AppContainerAcademy from './Academy/partials/AppContainerAcademy'
import AcademyBaseBackground from './Academy/partials/BaseBackground'

// 個別課金パッケージ
import PackageList from './Package/PackageList'
import PackageDetail from './Package/PackageDetail'

// 暮れの酉
import RecommendDetail from './recommend/RecommendDetail'
import SubscResult from './recommend/SubscResult'

// Line無料占い
import LineDailyDetail from './LineDaily/LineDailyDetail'

// 占い師LP群
import RecommendLpManager from './recommend/lp/RecommendLpManager'
import RecommendBasicResultManager from './recommend/lp/RecommendBasicResultManager'
import RecommendBasicInputManager from './recommend/lp/RecommendBasicInputManager'
import LineCampaign202110 from './lp/campaign/LineCampaign202110/index'
import TellerProfile from './teller/TellerProfile'
import TellerList from './teller/TellerList'

// ユルマール
import UlmarPaymentInput from './Ulmar/pages/PaymentInput'
import AppContainerUlmar from './Ulmar/partials/AppContainerUlmar'
import UlmarBaseBackground from './Ulmar/partials/BaseBackground'

// 高額商品
import DeluxeLpManager from './deluxe/DeluxeLpManager'
import DeluxeInputManager from './deluxe/DeluxeInputManager'
import DeluxeResultManager from './deluxe/DeluxeResultManager'

// ニュースページ
import NewsList from './News/NewsList'
import NewsDetail from './News/NewsDetail'

// 新コーナー叶ここ
import ProductsKanococoResult from './Products/kanococo/ProductsKanococoResult'

// 新コーナー暮れの酉
import ProductsKurenotoriIndex from './Products/kurenotori/ProductsKurenotoriIndex'
import ProductsKurenotoriInput from './Products/kurenotori/ProductsKurenotoriInput'
import ProductsKurenotoriResult from './Products/kurenotori/ProductsKurenotoriResult'

//新コーナー斗弥
import ProductsTouwaIndex from './Products/touwa/ProductsTouwaIndex'

// 新コーナー法演
import ProductsHouenIndex from './Products/houen/ProductsHouenIndex'
import ProductsHouenResult from './Products/houen/ProductsHouenResult'

// 新コーナーそまり百音
import ProductsSomariIndex from './Products/somarimone/ProductsSomariIndex'
import ProductsSomariInput from './Products/somarimone/ProductsSomariInput'
import ProductsSomariResult from './Products/somarimone/ProductsSomariResult'

// 年運2023
import yearLuck2023Top from './YearLuck/y2023/Yearluck2023Top'
import yearLuck2023Input from './YearLuck/y2023/Yearluck2023Input'
import yearLuck2023Result from './YearLuck/y2023/Yearluck2023Result'

const utvStore = {
  install(Vue, options) {
    Vue.component('app-container', AppContainer)
    Vue.component('app-copyright', AppCopyright)
    Vue.component('app-header', AppHeader)
    Vue.component('freeitems-list', FreeitemsList)
    Vue.component('videoletteritems-list', VideoletteritemsList)
    Vue.component('app-footer', AppFooter)
    Vue.component('counselors-list', CounselorsList)
    Vue.component('step-chart', StepChart)
    Vue.component('share-buttons', ShareButtons)
    Vue.component('store-video-player', StoreVideoPlayer)
    Vue.component('login-form', LoginForm)
    Vue.component('register-form', RegisterForm)
    Vue.component('entry-form', EntryForm)
    Vue.component('entry-form-line-daily', EntryFormLineDaily)
    Vue.component('entry-form-header', EntryFormHeader)
    Vue.component('entry-form-header-no-steps', EntryFormHeaderNoSteps)
    Vue.component('entry-form-header-special', EntryFormHeaderSpecial)
    Vue.component('entry-form-header-line-daily', EntryFormHeaderLineDaily)
    Vue.component('entry-confirm', EntryConfirm)
    Vue.component('entry-confirm-line-daily', EntryConfirmLineDaily)
    Vue.component('profile-viewer', ProfileViewer)
    Vue.component('product-detail', ProductDetail)
    Vue.component('story-trial', StoryTrial)
    Vue.component('story-recomend', StoryRecomend)
    Vue.component('story-result', StoryResult)
    Vue.component('story-result-second-half', StoryResultSecondHalf)
    Vue.component('story-result-special', StoryResultSpecial)
    Vue.component('app-loading', AppLoading)
    Vue.component('app-carousel', AppCarousel)
    Vue.component('uranai-img', UranaiImg)
    Vue.component('credit-card-form', CreditCardForm)
    Vue.component('inquiry-form', InquiryForm)
    Vue.component('app-dialog', AppDialog)
    Vue.component('app-modal', AppModal)
    Vue.component('app-modal-simple', AppModalSimple)
    Vue.component('app-modal-image', AppModalImage)
    Vue.component('lottery-items', LotteryItems)
    Vue.component('story-summary', StorySummary)
    Vue.component('payment-method-select', PaymentMethodSelect)
    Vue.component('change-payment-dialog', ChangePaymentDialog)
    Vue.component('change-payment-type', ChangePaymentType)
    Vue.component('last-payment', LastPayment)
    Vue.component('amazon-pay-button', AmazonPayButton)
    Vue.component('confirmation-purchase', ConfirmationPurchase)
    Vue.component('firstcome-showcase', FirstcomeShowcase)
    Vue.component('videoletter-product-detail', VideoletterProductDetail)
    Vue.component('comment-input', CommentInput)
    Vue.component('entry-confirm', EntryConfirm)
    Vue.component('trial-half-period', TrialHalfPeriod)
    Vue.component('half-carousel', HalfCarousel)
    Vue.component('second-recommend', SecondRecommend)
    Vue.component('firstcome-showcase-halfprice', FirstcomeShowcaseHalfprice)
    Vue.component('videoletter-product-detail-halfprice', VideoletterProductDetailHalfprice)
    Vue.component('scroll-top', ScrollTop)
    Vue.component('toppage-scroll-top', ToppageScrollTop)
    Vue.component('modern-list', ModernList)
    Vue.component('uragei-list', UrageiList)
    Vue.component('modern-counselor-card', ModernCounselorCard)
    Vue.component('show-sample', ShowSample)
    Vue.component('pop-up-footer', PopUpFooter)
    Vue.component('item-detail-text', ItemDetailText)
    Vue.component('item-detail-header', ItemDetailHeader)
    Vue.component('promotion-container', PromotionContainer)
    Vue.component('videoletter-list', VideoletterList)
    Vue.component('videoletter-empty', VideoletterEmpty)
    Vue.component('result-header', ResultHeader)

    Vue.component('loading-full-page', LoadingFullPage)
    Vue.component('sns-register', SnsRegister)
    Vue.component('sns-login', SnsLogin)
    Vue.component('profile-form', ProfileForm)
    Vue.component('nickname-form', NicknameForm)
    Vue.component('snsregist-form', SnsregistForm)
    Vue.component('payment-form', PaymentForm)
    Vue.component('sns-relation', SnsRelation)
    Vue.component('login-controllers', LoginControllers)
    Vue.component('pre-login', PreLogin)
    Vue.component('sign-in-action-panel', SignInActionPanel)
    Vue.component('sign-up-action-panel', SignUpActionPanel)
    Vue.component('identification-controllers', IdentificationControllers)
    Vue.component('information-shop', InformationShop)
    Vue.component('information-message', InformationMessage)
    Vue.component('provisional-regist', ProvisionalRegist)
    Vue.component('re-auth-form', ReAuthForm)
    Vue.component('tweet-list', TweetList)
    Vue.component('movie-modal', MovieModal)
    Vue.component('item-link', ItemLink)
    Vue.component('read-list', ReadList)

    Vue.component('lp-licorice', LpLicorice)
    Vue.component('sns-licorice', SnsLicorice)
    Vue.component('licorice-video-player', LicoriceVideoPlayer)
    Vue.component('licorice-complete', LicoriceComplete)

    Vue.component('top-daily-fortune', TopDailyFortune)
    Vue.component('switch-form', SwitchForm)

    Vue.component('comment-list', CommentList)
    Vue.component('top-star-manage', TopStarManage)
    Vue.component('evaluate-stars', EvaluateStars)

    Vue.component('store-video-sample-menu', StoreVideoSampleMenu)
    Vue.component('modern-list2', ModernList2)
    Vue.component('sale-banner', SaleBanner)
    Vue.component('personality-list', PersonalityList)
    Vue.component('category-uranai-list', CategoryUranaiList)
    Vue.component('bread-crumb', BreadCrumb)

    Vue.component('yearluck-2020-top', YearLuck2020Top)
    Vue.component('yearluck-2020-summary', YearLuck2020Summary)
    Vue.component('yearluck-2020-result', YearLuck2020Result)
    Vue.component('yearluck-2020-result-set', YearLuck2020ResultSet)

    Vue.component('password-change', PasswordChange)
    Vue.component('regist-controllers', RegistControllers)
    Vue.component('subsc-confirm', SubscConfirm)
    Vue.component('subsc-complete', SubscComplete)
    Vue.component('regist-user-info', RegistUserInfo)
    Vue.component('payment-regist-form', PaymentRegistForm)
    Vue.component('subsc-rejoin', SubscRejoin)
    Vue.component('payment-status', PaymentStatus)
    // Vue.component('shortage-user-info', ShortageUserInfo)

    // サブスク関連
    Vue.component('select-theme-worried', SelectThemeWorried)
    Vue.component('subsc-cancel', SubscCancel)
    Vue.component('subsc-cancel-complete', SubscCancelComplete)
    Vue.component('subsc-changed-mind', SubscChangedMind)
    Vue.component('subsc-suspension-error', SubscSuspensionError)

    // 超運ダイアリー関連
    Vue.component('payment-choun-regist-form', PaymentChounRegistForm)

    // 特典系
    Vue.component('entry-kantei', EntryKantei)
    Vue.component('confirm-kantei', ConfirmKantei)
    Vue.component('complete-kantei', CompleteKantei)

    Vue.component('present-movie', PresentMovie)
    Vue.component('buy-button', BuyButton)

    Vue.component('top-page', TopPage)

    // アカウント関連 - アカウントを管理
    Vue.component('account-edit', AccountEdit)
    Vue.component('email-form', EmailForm)
    Vue.component('user-account-email-send', UserAccountEmailSend)
    Vue.component('user-account-email-complete', UserAccountEmailComplete)
    Vue.component('user-account-password-confirm', UserAccountPasswordConfirm)
    Vue.component('user-account-password', UserAccountPassword)
    Vue.component('reissue-password-form', ReissuePasswordForm)
    Vue.component('user-account-password-complete', UserAccountPasswordComplete)
    Vue.component('mail-mag-config', MailMagConfig)

    // アカウント関連 - アカウントを管理
    Vue.component('user-account-point', UserAccountPoint)

    // 決済系
    Vue.component('payment-library', PaymentLibrary)

    // プレイリスト
    Vue.component('playlist-base', PlaylistBase)

    // ヘルプ
    Vue.component('help-page', HelpPage)
    Vue.component('faq-page', FaqPage)
    Vue.component('legal-page', LegalPage)
    Vue.component('privacy-page', PrivacyPage)
    Vue.component('terms-page', TermsPage)
    Vue.component('cookie-page', CookiePage)
    Vue.component('payment-history', PaymentHistory)
    Vue.component('announcement-page', AnnouncementPage)
    Vue.component('termination-page', TerminationPage)

    //デジコンエラーページ
    Vue.component('outof-service', OutofService)

    Vue.component('multiple-partner-list', MultiplePartnerList)

    // 年運2021
    Vue.component('year-luck-2021-top', yearLuck2021Top)
    Vue.component('year-luck-2021-lp', yearLuck2021Lp)
    Vue.component('year-luck-2021-result', yearLuck2021Result)

    // 年運2022
    Vue.component('year-luck-2022-top', yearLuck2022Top)
    Vue.component('year-luck-2022-lp', yearLuck2022Lp)
    Vue.component('year-luck-2022-result', yearLuck2022Result)

    //超運ダイアリー課金
    Vue.component('app-container-choun', AppContainerChoun)
    Vue.component('payment-status-choun', PaymentStatusChoun)
    Vue.component('payment-form-choun', PaymentFormChoun)
    Vue.component('payment-detail-choun', PaymentDetailChoun)
    Vue.component('cancel-choun', CancelChoun)
    Vue.component('subsc-confirm-choun', SubscConfirmChoun)

    // LP
    Vue.component('cutout01', Cutout01)

    // アカデミー
    Vue.component('academy-payment-status', AcademyPaymentStatus)
    Vue.component('academy-payment-form', AcademyPaymentForm)
    Vue.component('academy-payment-input', AcademyPaymentInput)
    Vue.component('app-container-academy', AppContainerAcademy)
    Vue.component('academy-base-background', AcademyBaseBackground)

    //個別課金パッケージ
    Vue.component('package-list', PackageList)
    Vue.component('package-detail', PackageDetail)

    //暮れの酉
    Vue.component('recommend-detail', RecommendDetail)
    Vue.component('subsc-result', SubscResult)

    // Line無料占い
    Vue.component('line-daily-detail', LineDailyDetail)

    //占い師LP群
    Vue.component('recommend-lp-manager', RecommendLpManager)
    Vue.component('recommend-basic-result-manager', RecommendBasicResultManager)
    Vue.component('recommend-basic-input-manager', RecommendBasicInputManager)
    Vue.component('line-campaign202110', LineCampaign202110)
    Vue.component('teller-profile', TellerProfile)
    Vue.component('teller-list', TellerList)

    // ユルマール
    Vue.component('ulmar-payment-input', UlmarPaymentInput)
    Vue.component('app-container-ulmar', AppContainerUlmar)
    Vue.component('ulmar-base-background', UlmarBaseBackground)

    // 高額メニュー
    Vue.component('deluxe-lp-manager', DeluxeLpManager)
    Vue.component('deluxe-input-manager', DeluxeInputManager)
    Vue.component('deluxe-result-manager', DeluxeResultManager)

    // 高額メニュー
    Vue.component('news-list', NewsList)
    Vue.component('news-detail', NewsDetail)

    // 新コーナー叶ここ
    Vue.component('products-kanococo-result', ProductsKanococoResult)

    // 新コーナー暮れの酉
    Vue.component('products-kurenotori-index', ProductsKurenotoriIndex)
    Vue.component('products-kurenotori-input', ProductsKurenotoriInput)
    Vue.component('products-kurenotori-result', ProductsKurenotoriResult)

    //新コーナー斗弥
    Vue.component('products-touwa-index', ProductsTouwaIndex)

    // 新コーナー法演
    Vue.component('products-houen-index', ProductsHouenIndex)
    Vue.component('products-houen-result', ProductsHouenResult)

    // 新コーナーそまり百音
    Vue.component('products-somari-index', ProductsSomariIndex)
    Vue.component('products-somari-input', ProductsSomariInput)
    Vue.component('products-somari-result', ProductsSomariResult)

    // 年運2023
    Vue.component('yearluck-2023-top', yearLuck2023Top)
    Vue.component('yearluck-2023-input', yearLuck2023Input)
    Vue.component('yearluck-2023-result', yearLuck2023Result)
  }
}

export default utvStore



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/index.js